import { useEffect } from 'react';
import { useValidationContext } from '../validation-context';

export const FormValidation = () => {
  const {
    onContinue,
    onCancel,
    setAlwaysShowError,
    validateForm,
  } = useValidationContext();

  useEffect(() => {
    setAlwaysShowError(true);

    if (!validateForm()) {
      onCancel();
    } else {
      onContinue();
    }
  // We should only call this once when component did mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
